import { render, staticRenderFns } from "./SectionEditor.vue?vue&type=template&id=5bfa2f82&"
import script from "./SectionEditor.vue?vue&type=script&lang=js&"
export * from "./SectionEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports